import * as i0 from '@angular/core';
import { Pipe, EventEmitter, Component, ViewChild, Input, Output, Injectable, ViewContainerRef, NgModule } from '@angular/core';
import * as i1$2 from '@roosevelt/common-ui-lib/core';
import { coerceBooleanProperty } from '@roosevelt/common-ui-lib/core';
import * as i2 from '@roosevelt/common-ui-lib/button';
import { ButtonModule } from '@roosevelt/common-ui-lib/button';
import * as i3$2 from '@roosevelt/common-ui-lib/loader';
import { LoaderModule } from '@roosevelt/common-ui-lib/loader';
import * as i2$1 from '@roosevelt/common-ui-lib/notification';
import { NotificationModule } from '@roosevelt/common-ui-lib/notification';
import * as i1 from '@angular/forms';
import { Validators, ReactiveFormsModule } from '@angular/forms';
import * as i4 from '@roosevelt/common-ui-lib/input';
import { InputModule } from '@roosevelt/common-ui-lib/input';
import * as i3 from '@roosevelt/common-ui-lib/icon';
import { IconModule } from '@roosevelt/common-ui-lib/icon';
import * as i3$1 from '@roosevelt/common-ui-lib/select';
import { SelectModule } from '@roosevelt/common-ui-lib/select';
import { of, tap, mergeMap, map, catchError, throwError, first } from 'rxjs';
import * as i1$1 from '@angular/common/http';
import * as i2$2 from '@angular/common';
import { CommonModule } from '@angular/common';

class PhonePipe {
    transform(value, ...args) {
        return value.replace(/\D+/g, '').replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '+$1 ($2) $3-$4');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: PhonePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.3", ngImport: i0, type: PhonePipe, isStandalone: true, name: "phone" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: PhonePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'phone',
                    standalone: true
                }]
        }] });

class FactorComponent {
    get pack() {
        return this._pack;
    }
    set pack(value) {
        this._pack = value;
        if (value.enrollmentStatus === 'none' && this.factorVerifyForm) {
            this.factorVerifyForm.reset({ code: '' });
        }
        else if (value.enrollmentStatus === 'verify-new' || value.enrollmentStatus === 'verify-pending') {
            setTimeout(() => {
                this.codeInput.focus();
            }, 0);
        }
    }
    constructor(fb) {
        this.codeInput = undefined;
        this.labels = undefined;
        this.profileKey = undefined;
        this.nextStep = new EventEmitter();
        this.continueEnrollment = new EventEmitter();
        this.resetResendStatus = new EventEmitter();
        this.resendCode = new EventEmitter();
        this.edit = new EventEmitter();
        this.verifyCode = new EventEmitter();
        this.removeFactor = new EventEmitter();
        this.factorVerifyForm = undefined;
        this.codeMask = { mask: '000000' };
        this._pack = undefined;
        this.factorVerifyForm = fb.group({
            code: ['', Validators.required]
        });
    }
    submitVerification() {
        if (this.factorVerifyForm.valid) {
            this.verifyCode.emit(this.factorVerifyForm.value.code);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: FactorComponent, deps: [{ token: i1.FormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.3", type: FactorComponent, isStandalone: true, selector: "lib-factor", inputs: { labels: "labels", profileKey: "profileKey", pack: "pack" }, outputs: { nextStep: "nextStep", continueEnrollment: "continueEnrollment", resetResendStatus: "resetResendStatus", resendCode: "resendCode", edit: "edit", verifyCode: "verifyCode", removeFactor: "removeFactor" }, viewQueries: [{ propertyName: "codeInput", first: true, predicate: ["code"], descendants: true }], ngImport: i0, template: "<div class=\"factor\">\n  <div class=\"factor-header\">\n    <div class=\"factor-title\">\n      <h4>{{labels.title}}</h4>\n      <span></span>\n      @if (pack.enrollmentStatus === 'none' && !pack.factors.length) {\n        <button rs-raised-button (click)=\"nextStep.emit('setup')\"\n        >{{labels.createBtn}}</button>\n      }\n    </div>\n    @if (labels.description) {\n      <em class=\"factor-description\"><rs-icon>alert</rs-icon>{{labels.description}}</em>\n    }\n  </div>\n\n  @if (pack.enrollmentStatus === 'none') {\n    @for (enrollment of pack.factors; track $index) {\n      <!-- <rs-notification type=\"success\" *ngIf=\"enrollment.status === 'JUST_ADDED'\" [visible]=\"!successNotification\"\n      closeable (visibleChange)=\"successNotification = !$event\"\n    [message]=\" phoneNumber + ' successfully added'\"></rs-notification> -->\n    @if (pack.errors) {\n      <rs-notification type=\"error\" visible\n      [message]=\"pack.errors === 'RESEND_ERROR' ? labels.verifySendFailed : labels.removeFailed\"></rs-notification>\n    }\n    <div class=\"factor-enrolled\">\n      <b>{{$any(enrollment.profile)[profileKey] | phone}}</b>\n      <span></span>\n      @if (enrollment.status === 'ACTIVE') {\n        <button rs-outlined-button (click)=\"removeFactor.emit(enrollment.id)\">{{labels.enrolledRemove}}</button>\n      }\n      @if (enrollment.status === 'PENDING_ACTIVATION') {\n        <button rs-button (click)=\"removeFactor.emit(enrollment.id)\">{{labels.enrolledRemove}}</button>\n        <button rs-outlined-button color=\"secondary\"\n        (click)=\"continueEnrollment.emit(enrollment)\">{{labels.continueEnrollment}}</button>\n      }\n    </div>\n  }\n  @if (!pack.factors.length) {\n    <p class=\"factor-not-enrolled\">\n      {{labels.noEnrolled}}\n    </p>\n  }\n}\n\n@if (pack.enrollmentStatus === 'setup') {\n  <ng-content></ng-content>\n}\n\n@if (pack.enrollmentStatus === 'verify-new' || pack.enrollmentStatus === 'verify-pending') {\n  <rs-notification [type]=\"$any(pack.resendStatus.status)\" [visible]=\"pack.resendStatus.status !== 'none'\"\n    displayTimeout=\"10000\" (visibleChange)=\"resetResendStatus.emit()\"\n  [message]=\"pack.resendStatus.status !== 'error' ? labels.verifySendSuccess : labels.verifySendFailed\"></rs-notification>\n  @if (pack.errors && pack.errors !== 'RESEND_ERROR') {\n    <rs-notification type=\"error\" visible\n    [message]=\"labels.verifyCodeFailed\"></rs-notification>\n  }\n  <form class=\"row\" (ngSubmit)=\"submitVerification()\" [formGroup]=\"factorVerifyForm\">\n    <div class=\"col-12\">\n      <p class=\"factor-verify-description\">\n        <b>{{$any(pack.continuedEnrollment.profile)[profileKey] | phone}}</b>\n        {{labels.verifyDescription}}\n      </p>\n    </div>\n    <div class=\"col-12\">\n      <p class=\"factor-verify-description\">{{labels.verifyResendDescription}}\n        <button rs-button type=\"button\" (click)=\"resendCode.emit()\">{{labels.verifyResendBtn}}</button>\n      </p>\n    </div>\n    @if (pack.enrollmentStatus === 'verify-new') {\n      <div class=\"col-12\">\n        <p class=\"factor-verify-description\">{{labels.verifyEditDescription}}\n          <button rs-button type=\"button\"\n          (click)=\"edit.emit(pack.continuedEnrollment.id)\">{{labels.verifyEditBtn}}</button>\n        </p>\n      </div>\n    }\n    <div class=\"col-12\">\n      <rs-input [label]=\"labels.verifyCodeLabel\" #code formControlName=\"code\" validation=\"eager\"\n      [mask]=\"codeMask\"></rs-input>\n    </div>\n    <div class=\"col-12 factor-setup-actions\">\n      <button rs-button type=\"button\" (click)=\"nextStep.emit('none')\">{{labels.cancelBtn}}</button>\n      <button rs-raised-button>{{labels.verifyCodeBtn}}</button>\n    </div>\n  </form>\n}\n</div>\n", styles: [":host *,:host *:before,:host *:after{box-sizing:border-box}:host ::ng-deep rs-notification h3{font-size:16px}p{margin:0}.factor{margin:0 20px 20px;max-width:575px}.factor .factor-header{display:flex;flex-direction:column;border-bottom:solid 2px;align-items:center;flex-wrap:wrap;margin-bottom:30px}.factor .factor-header .factor-title{width:100%;flex:1;display:flex;padding:20px 0;align-items:flex-end;height:80px}.factor .factor-header .factor-title h4{margin:0}.factor .factor-header .factor-title span{flex:1}.factor .factor-header .factor-description{padding-bottom:20px;flex:1;display:flex;justify-content:center;align-items:center;width:100%}.factor .factor-header .factor-description rs-icon{font-size:20px;margin-right:10px}.factor .factor-enrolled{display:flex;align-items:center;margin-bottom:10px}.factor .factor-enrolled span{flex:1}.factor .factor-not-enrolled{display:flex;align-items:center;justify-content:center;background-color:#f3f3f3;height:150px;border-radius:5px;margin-top:-25px}.factor .factor-verify-decription{margin-bottom:10px}.factor .factor-verify-decription button{padding:0;margin-left:10px;min-width:auto}.factor-setup-actions{display:flex;flex-direction:column-reverse;text-align:right}.factor-setup-actions button{width:100%;margin-bottom:10px}.factor-setup-actions button:first{margin-right:10px}@media (min-width: 768px){.factor-setup-actions{display:flex;flex-direction:row;justify-content:flex-end}.factor-setup-actions button{width:auto;margin-bottom:0}}\n"], dependencies: [{ kind: "ngmodule", type: ButtonModule }, { kind: "component", type: i2.ButtonComponent, selector: "button[rs-button], button[rs-raised-button], button[rs-outlined-button]", inputs: ["color"] }, { kind: "ngmodule", type: IconModule }, { kind: "component", type: i3.IconComponent, selector: "rs-icon" }, { kind: "ngmodule", type: NotificationModule }, { kind: "component", type: i2$1.NotificationComponent, selector: "rs-notification", inputs: ["visible", "toast", "displayTimeout", "message", "type", "customConfig", "checkPasswordExpiry", "customExpirationMessage", "closeable"], outputs: ["visibleChange"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "ngmodule", type: InputModule }, { kind: "component", type: i4.InputComponent, selector: "rs-input", inputs: ["autocomplete", "list", "suffix", "prefix", "placeholder", "size", "step", "maxlength", "label", "max", "min", "validation", "errors", "value", "mask", "type", "hideErrorMessage", "tabindex", "id", "disabled", "color"] }, { kind: "pipe", type: PhonePipe, name: "phone" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: FactorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-factor', standalone: true, imports: [ButtonModule, IconModule, NotificationModule, ReactiveFormsModule, InputModule, PhonePipe], template: "<div class=\"factor\">\n  <div class=\"factor-header\">\n    <div class=\"factor-title\">\n      <h4>{{labels.title}}</h4>\n      <span></span>\n      @if (pack.enrollmentStatus === 'none' && !pack.factors.length) {\n        <button rs-raised-button (click)=\"nextStep.emit('setup')\"\n        >{{labels.createBtn}}</button>\n      }\n    </div>\n    @if (labels.description) {\n      <em class=\"factor-description\"><rs-icon>alert</rs-icon>{{labels.description}}</em>\n    }\n  </div>\n\n  @if (pack.enrollmentStatus === 'none') {\n    @for (enrollment of pack.factors; track $index) {\n      <!-- <rs-notification type=\"success\" *ngIf=\"enrollment.status === 'JUST_ADDED'\" [visible]=\"!successNotification\"\n      closeable (visibleChange)=\"successNotification = !$event\"\n    [message]=\" phoneNumber + ' successfully added'\"></rs-notification> -->\n    @if (pack.errors) {\n      <rs-notification type=\"error\" visible\n      [message]=\"pack.errors === 'RESEND_ERROR' ? labels.verifySendFailed : labels.removeFailed\"></rs-notification>\n    }\n    <div class=\"factor-enrolled\">\n      <b>{{$any(enrollment.profile)[profileKey] | phone}}</b>\n      <span></span>\n      @if (enrollment.status === 'ACTIVE') {\n        <button rs-outlined-button (click)=\"removeFactor.emit(enrollment.id)\">{{labels.enrolledRemove}}</button>\n      }\n      @if (enrollment.status === 'PENDING_ACTIVATION') {\n        <button rs-button (click)=\"removeFactor.emit(enrollment.id)\">{{labels.enrolledRemove}}</button>\n        <button rs-outlined-button color=\"secondary\"\n        (click)=\"continueEnrollment.emit(enrollment)\">{{labels.continueEnrollment}}</button>\n      }\n    </div>\n  }\n  @if (!pack.factors.length) {\n    <p class=\"factor-not-enrolled\">\n      {{labels.noEnrolled}}\n    </p>\n  }\n}\n\n@if (pack.enrollmentStatus === 'setup') {\n  <ng-content></ng-content>\n}\n\n@if (pack.enrollmentStatus === 'verify-new' || pack.enrollmentStatus === 'verify-pending') {\n  <rs-notification [type]=\"$any(pack.resendStatus.status)\" [visible]=\"pack.resendStatus.status !== 'none'\"\n    displayTimeout=\"10000\" (visibleChange)=\"resetResendStatus.emit()\"\n  [message]=\"pack.resendStatus.status !== 'error' ? labels.verifySendSuccess : labels.verifySendFailed\"></rs-notification>\n  @if (pack.errors && pack.errors !== 'RESEND_ERROR') {\n    <rs-notification type=\"error\" visible\n    [message]=\"labels.verifyCodeFailed\"></rs-notification>\n  }\n  <form class=\"row\" (ngSubmit)=\"submitVerification()\" [formGroup]=\"factorVerifyForm\">\n    <div class=\"col-12\">\n      <p class=\"factor-verify-description\">\n        <b>{{$any(pack.continuedEnrollment.profile)[profileKey] | phone}}</b>\n        {{labels.verifyDescription}}\n      </p>\n    </div>\n    <div class=\"col-12\">\n      <p class=\"factor-verify-description\">{{labels.verifyResendDescription}}\n        <button rs-button type=\"button\" (click)=\"resendCode.emit()\">{{labels.verifyResendBtn}}</button>\n      </p>\n    </div>\n    @if (pack.enrollmentStatus === 'verify-new') {\n      <div class=\"col-12\">\n        <p class=\"factor-verify-description\">{{labels.verifyEditDescription}}\n          <button rs-button type=\"button\"\n          (click)=\"edit.emit(pack.continuedEnrollment.id)\">{{labels.verifyEditBtn}}</button>\n        </p>\n      </div>\n    }\n    <div class=\"col-12\">\n      <rs-input [label]=\"labels.verifyCodeLabel\" #code formControlName=\"code\" validation=\"eager\"\n      [mask]=\"codeMask\"></rs-input>\n    </div>\n    <div class=\"col-12 factor-setup-actions\">\n      <button rs-button type=\"button\" (click)=\"nextStep.emit('none')\">{{labels.cancelBtn}}</button>\n      <button rs-raised-button>{{labels.verifyCodeBtn}}</button>\n    </div>\n  </form>\n}\n</div>\n", styles: [":host *,:host *:before,:host *:after{box-sizing:border-box}:host ::ng-deep rs-notification h3{font-size:16px}p{margin:0}.factor{margin:0 20px 20px;max-width:575px}.factor .factor-header{display:flex;flex-direction:column;border-bottom:solid 2px;align-items:center;flex-wrap:wrap;margin-bottom:30px}.factor .factor-header .factor-title{width:100%;flex:1;display:flex;padding:20px 0;align-items:flex-end;height:80px}.factor .factor-header .factor-title h4{margin:0}.factor .factor-header .factor-title span{flex:1}.factor .factor-header .factor-description{padding-bottom:20px;flex:1;display:flex;justify-content:center;align-items:center;width:100%}.factor .factor-header .factor-description rs-icon{font-size:20px;margin-right:10px}.factor .factor-enrolled{display:flex;align-items:center;margin-bottom:10px}.factor .factor-enrolled span{flex:1}.factor .factor-not-enrolled{display:flex;align-items:center;justify-content:center;background-color:#f3f3f3;height:150px;border-radius:5px;margin-top:-25px}.factor .factor-verify-decription{margin-bottom:10px}.factor .factor-verify-decription button{padding:0;margin-left:10px;min-width:auto}.factor-setup-actions{display:flex;flex-direction:column-reverse;text-align:right}.factor-setup-actions button{width:100%;margin-bottom:10px}.factor-setup-actions button:first{margin-right:10px}@media (min-width: 768px){.factor-setup-actions{display:flex;flex-direction:row;justify-content:flex-end}.factor-setup-actions button{width:auto;margin-bottom:0}}\n"] }]
        }], ctorParameters: () => [{ type: i1.FormBuilder }], propDecorators: { codeInput: [{
                type: ViewChild,
                args: ['code']
            }], labels: [{
                type: Input
            }], profileKey: [{
                type: Input
            }], pack: [{
                type: Input
            }], nextStep: [{
                type: Output
            }], continueEnrollment: [{
                type: Output
            }], resetResendStatus: [{
                type: Output
            }], resendCode: [{
                type: Output
            }], edit: [{
                type: Output
            }], verifyCode: [{
                type: Output
            }], removeFactor: [{
                type: Output
            }] } });
class FactorLabelModel {
    constructor() {
        this.verifyCodeLabel = 'Code';
        this.verifyDescription = ' has been sent a code. When you receieve the code please return here and enter it in the textbox below.';
        this.verifyEditDescription = '';
        this.verifyEditBtn = 'Edit';
        this.verifyResendDescription = 'Didn\'t receive a code?';
        this.verifyResendBtn = 'Resend';
        this.verifyCodeBtn = 'Verify Code';
        this.verifySendFailed = 'Failed to send code. Please retry after 30 seconds.';
        this.verifySendSuccess = 'Code sent succesfully';
        this.verifyCodeFailed = 'We are unable to verify your code. Please try again.';
        this.title = '';
        this.description = '';
        this.createBtn = '';
        this.noEnrolled = '';
        this.continueEnrollment = 'Continue Enrollment';
        this.enrolledRemove = 'Remove';
        this.cancelBtn = 'Cancel';
        this.removeFailed = 'Failed to remove this factor.';
    }
}

const countryCodes = [
    /* 'Afghanistan - 93',
    'Åland - 358 (18)',
    'Albania - 355',
    'Algeria - 213',
    'American Samoa - 1 (684)',
    'Andorra - 376',
    'Angola - 244',
    'Anguilla - 1 (264)',
    'Antigua and Barbuda - 1 (268)',
    'Argentina - 54',
    'Armenia - 374',
    'Aruba - 297',
    'Ascension - 247',
    'Australia - 61',
    'Austria - 43',
    'Azerbaijan - 994',
    'Bahamas - 1 (242)',
    'Bahrain - 973',
    'Bangladesh - 880',
    'Barbados - 1 (246)',
    'Belarus - 375',
    'Belgium - 32',
    'Belize - 501',
    'Benin - 229',
    'Bermuda - 1 (441)',
    'Bhutan - 975',
    'Bolivia - 591',
    'Bonaire - 599 (7)',
    'Bosnia and Herzegovina - 387',
    'Botswana - 267',
    'Brazil - 55',
    'British Indian Ocean Territory (Diego Garcia) - 246',
    'British Virgin Islands - 1 (284)',
    'Brunei Darussalam - 673',
    'Bulgaria - 359',
    'Burkina Faso - 226',
    'Burundi - 257',
    'Cape Verde - 238',
    'Cambodia - 855',
    'Cameroon - 237',
    'Canada - 1',
    'Caribbean Netherlands - 599 (3,4,7)',
    'Cayman Islands - 1 (345)',
    'Central African Republic - 236',
    'Chad - 235',
    'Chile - 56',
    'China - 86',
    'Christmas Island - 61 (89164)',
    'Cocos (Keeling) Islands - 61 (89162)',
    'Colombia - 57',
    'Comoros - 269',
    'Congo - 242',
    'Congo, Democratic Republic of the - 243',
    'Cook Islands - 682',
    'Costa Rica - 506',
    'Ivory Coast (Côte dIvoire) - 225',
    'Croatia - 385',
    'Cuba - 53',
    'Curaçao - 599 (9)',
    'Cyprus - 357',
    'Czech Republic - 420',
    'Denmark - 45',
    'Djibouti - 253',
    'Dominica - 1 (767)',
    'Dominican Republic - 1 (809, 829, 849) ',
    'Easter Island - 56',
    'Ecuador - 593',
    'Egypt - 20',
    'El Salvador - 503',
    'Ellipso (Mobile Satellite service) - 881 (2, 3) ',
    'EMSAT (Mobile Satellite service) - 882 (13)',
    'Equatorial Guinea - 240',
    'Eritrea - 291',
    'Estonia - 372',
    'Eswatini - 268',
    'Ethiopia - 251',
    'Falkland Islands - 500',
    'Faroe Islands - 298',
    'Fiji - 679',
    'Finland - 358',
    'France - 33',
    'French Antilles - 596',
    'French Guiana - 594',
    'French Polynesia - 689',
    'Gabon - 241',
    'Gambia - 220',
    'Georgia - 995',
    'Germany - 49',
    'Ghana - 233',
    'Gibraltar - 350',
    'Global Mobile Satellite System (GMSS) - 881',
    'Globalstar (Mobile Satellite Service) - 881 (8, 9) ',
    'Greece - 30',
    'Greenland - 299',
    'Grenada - 1 (473)',
    'Guadeloupe - 590',
    'Guam - 1 (671)',
    'Guatemala - 502',
    'Guernsey - 44 (1481, 7781, 7839, 7911) ',
    'Guinea - 224',
    'Guinea-Bissau - 245',
    'Guyana - 592',
    'Haiti - 509',
    'Honduras - 504',
    'Hong Kong - 852',
    'Hungary - 36',
    'Iceland - 354',
    'ICO Global (Mobile Satellite Service) - 881 (0, 1) ',
    'India - 91',
    'Indonesia - 62',
    'Inmarsat SNAC - 870',
    'International Freephone Service (UIFN) - 800',
    'International Networks - 882, 883',
    'International Premium Rate Service - 979',
    'International Shared Cost Service (ISCS) - 808',
    'Iran - 98',
    'Iraq - 964',
    'Ireland - 353',
    'Iridium (Mobile Satellite service) - 881 (6, 7) ',
    'Isle of Man - 44 (1624, 7524, 7624, 7924) ',
    'Israel - 972',
    'Italy - 39',
    'Jamaica - 1 (658, 876) ',
    'Jan Mayen - 47 (79)',
    'Japan - 81',
    'Jersey - 44 (1534)',
    'Jordan - 962',
    'Kazakhstan - 7 (6, 7) (997 assigned but unused) ',
    'Kenya - 254',
    'Kiribati - 686',
    'Korea, North - 850',
    'Korea, South - 82',
    'Kosovo - 383',
    'Kuwait - 965',
    'Kyrgyzstan - 996',
    'Laos - 856',
    'Latvia - 371',
    'Lebanon - 961',
    'Lesotho - 266',
    'Liberia - 231',
    'Libya - 218',
    'Liechtenstein - 423',
    'Lithuania - 370',
    'Luxembourg - 352',
    'Macau - 853',
    'Madagascar - 261',
    'Malawi - 265',
    'Malaysia - 60',
    'Maldives - 960',
    'Mali - 223',
    'Malta - 356',
    'Marshall Islands - 692',
    'Martinique - 596',
    'Mauritania - 222',
    'Mauritius - 230',
    'Mayotte - 262 (269, 639) ',
    'Mexico - 52',
    'Micronesia, Federated States of - 691',
    'Moldova - 373',
    'Monaco - 377',
    'Mongolia - 976',
    'Montenegro - 382',
    'Montserrat - 1 (664)',
    'Morocco - 212',
    'Mozambique - 258',
    'Myanmar - 95',
    'Artsakh - 374 (47, 97) ',
    'Namibia - 264',
    'Nauru - 674',
    'Nepal - 977',
    'Netherlands - 31',
    'Nevis - 1 (869)',
    'New Caledonia - 687',
    'New Zealand - 64',
    'Nicaragua - 505',
    'Niger - 227',
    'Nigeria - 234',
    'Niue - 683',
    'Norfolk Island - 672 (3)',
    'North Macedonia - 389',
    'Northern Cyprus - 90 (392)',
    'Northern Ireland - 44 (28)',
    'Northern Mariana Islands - 1 (670)',
    'Norway - 47',
    'Oman - 968',
    'Pakistan - 92',
    'Palau - 680',
    'Palestine, State of - 970',
    'Panama - 507',
    'Papua New Guinea - 675',
    'Paraguay - 595',
    'Peru - 51',
    'Philippines - 63',
    'Pitcairn Islands - 64',
    'Poland - 48',
    'Portugal - 351',
    'Puerto Rico - 1 (787, 930) ',
    'Qatar - 974',
    'Réunion - 262',
    'Romania - 40',
    'Russia - 7',
    'Rwanda - 250',
    'Saba - 599 (4)',
    'Saint Barthélemy - 590',
    'Saint Helena - 290',
    'Saint Kitts and Nevis - 1 (869)',
    'Saint Lucia - 1 (758)',
    'Saint Martin (France) - 590',
    'Saint Pierre and Miquelon - 508',
    'Saint Vincent and the Grenadines - 1 (784)',
    'Samoa - 685',
    'San Marino - 378',
    'São Tomé and Príncipe - 239',
    'Saudi Arabia - 966',
    'Senegal - 221',
    'Serbia - 381',
    'Seychelles - 248',
    'Sierra Leone - 232',
    'Singapore - 65',
    'Sint Eustatius - 599 (3)',
    'Sint Maarten (Netherlands) - 1 (721)',
    'Slovakia - 421',
    'Slovenia - 386',
    'Solomon Islands - 677',
    'Somalia - 252',
    'South Africa - 27',
    'South Georgia and the South Sandwich Islands - 500',
    'South Ossetia - 995 (34)',
    'South Sudan - 211',
    'Spain - 34',
    'Sri Lanka - 94',
    'Sudan - 249',
    'Suriname - 597',
    'Svalbard - 47 (79)',
    'Sweden - 46',
    'Switzerland - 41',
    'Syria - 963',
    'Taiwan - 886',
    'Tajikistan - 992',
    'Tanzania - 255',
    'Thailand - 66',
    'Thuraya (Mobile Satellite service) - 882 (16)',
    'East Timor (Timor-Leste) - 670',
    'Togo - 228',
    'Tokelau - 690',
    'Tonga - 676',
    'Transnistria - 373 (2, 5) ',
    'Trinidad and Tobago - 1 (868)',
    'Tristan da Cunha - 290 (8)',
    'Tunisia - 216',
    'Turkey - 90',
    'Turkmenistan - 993',
    'Turks and Caicos Islands - 1 (649)',
    'Tuvalu - 688',
    'Uganda - 256',
    'Ukraine - 380',
    'United Arab Emirates - 971',
    'United Kingdom - 44', */
    'United States - 1',
    /* 'Uruguay - 598',
    'US Virgin Islands - 1 (340)',
    'Uzbekistan - 998',
    'Vanuatu - 678',
    'Vatican City State (Holy See) - 39 (06698), assigned 379',
    'Venezuela - 58',
    'Vietnam - 84',
    'Wake Island, USA - 1 (808)',
    'Wallis and Futuna - 681',
    'Yemen - 967',
    'Zambia - 260',
    'Zanzibar - 255 (24)',
    'Zimbabwe - 263' */
];
const formats = {
    ['United Kingdom - 44']: {
        guide: false,
        mask: '00 0000 0000'
    },
    ['United States - 1']: {
        guide: false,
        mask: '(000) 000-0000'
    }
};

class PhoneFactorComponent {
    get pack() {
        return this._pack;
    }
    set pack(value) {
        this._pack = value;
        if (this.factorEnrollmentForm) {
            this.factorEnrollmentForm.controls['phoneNumber'].setValue((value?.continuedEnrollment?.profile?.phoneNumber || '').slice(-10));
        }
    }
    constructor(fb) {
        this.fb = fb;
        this.phoneInput = undefined;
        this.labels = undefined;
        this.nextStep = new EventEmitter();
        this.continueEnrollment = new EventEmitter();
        this.resetResendStatus = new EventEmitter();
        this.resendCode = new EventEmitter();
        this.edit = new EventEmitter();
        this.startVerification = new EventEmitter();
        this.verifyCode = new EventEmitter();
        this.removeFactor = new EventEmitter();
        this.countryCodes = countryCodes;
        this.factorEnrollmentForm = undefined;
        this.phoneMask = formats['United States - 1'];
        this.prefix = "+1";
        this._pack = undefined;
    }
    ngOnInit() {
        this.factorEnrollmentForm = this.fb.group({
            countryCode: ['United States - 1', Validators.required],
            phoneNumber: [this.pack.continuedEnrollment.profile.phoneNumber || '', [Validators.required, Validators.minLength(10)]]
        });
        this.factorEnrollmentForm.controls['countryCode'].valueChanges.subscribe(x => {
            this.phoneMask = formats[x];
            this.prefix = x ? '+' + x.split(' - ')[1].split(' ')[0] : '';
        });
    }
    submitEnrollment(type) {
        if (this.factorEnrollmentForm.valid) {
            const val = this.factorEnrollmentForm.value;
            const fullNumber = this.prefix + val.countryCode.split(' - ')[1].split(' ')[0] + val.phoneNumber;
            this.startVerification.emit({ type, phoneNumber: fullNumber });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: PhoneFactorComponent, deps: [{ token: i1.FormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.3", type: PhoneFactorComponent, isStandalone: true, selector: "ng-component", viewQueries: [{ propertyName: "phoneInput", first: true, predicate: ["phone"], descendants: true }], ngImport: i0, template: "<lib-factor [labels]=\"labels\" profileKey=\"phoneNumber\" [pack]=\"pack\" (nextStep)=\"nextStep.emit($event)\"\n  (continueEnrollment)=\"continueEnrollment.emit($event)\" (resendCode)=\"resendCode.emit($event)\"\n  (resetResendStatus)=\"resetResendStatus.emit($event)\" (verifyCode)=\"verifyCode.emit($event)\"\n  (removeFactor)=\"removeFactor.emit($event)\" (edit)=\"edit.emit($event)\">\n  @if (pack.errors) {\n    <rs-notification type=\"error\" [message]=\"labels.setupCodeFailed\" visible></rs-notification>\n  }\n  <p class=\"factor-setup-description\">{{labels.setupDescription}}</p>\n  <form class=\"row\" [formGroup]=\"factorEnrollmentForm\">\n    <div class=\"col-12 col-md-6\">\n      <rs-select validation=\"eager\" [label]=\"labels.setupCountryCodeLabel\" formControlName=\"countryCode\"\n      [items]=\"countryCodes\" searchable></rs-select>\n    </div>\n    <div class=\"col-12 col-md-6\">\n      <rs-input #phone [label]=\"labels.setupPhoneNubmerLabel\" validation=\"eager\" formControlName=\"phoneNumber\"\n        [mask]=\"phoneMask\">\n        <rs-input-prefix>{{prefix}}</rs-input-prefix>\n      </rs-input>\n    </div>\n    <div class=\"col-12 factor-setup-actions\">\n      <button rs-button type=\"button\" (click)=\"nextStep.emit('none')\">{{labels.cancelBtn}}</button>\n      <button rs-outlined-button type=\"button\" (click)=\"submitEnrollment('call')\">{{labels.setupVoiceBtn}}</button>\n      <button rs-raised-button (click)=\"submitEnrollment('sms')\" type=\"button\">{{labels.setupSMSBtn}}</button>\n    </div>\n  </form>\n</lib-factor>\n", styles: [":host *,:host *:before,:host *:after{box-sizing:border-box}:host ::ng-deep rs-notification h3{font-size:16px}p{margin:0}.factor-setup-description{padding-bottom:15px}.factor-setup-actions{display:flex;flex-direction:column-reverse;text-align:right}.factor-setup-actions button{width:100%;margin-bottom:10px;margin-right:10px}.factor-setup-actions button:last-of-type{margin-right:0}@media (min-width: 768px){.factor-setup-actions{display:flex;flex-direction:row;justify-content:flex-end}.factor-setup-actions button{width:auto;margin-bottom:0}}\n"], dependencies: [{ kind: "component", type: FactorComponent, selector: "lib-factor", inputs: ["labels", "profileKey", "pack"], outputs: ["nextStep", "continueEnrollment", "resetResendStatus", "resendCode", "edit", "verifyCode", "removeFactor"] }, { kind: "ngmodule", type: NotificationModule }, { kind: "component", type: i2$1.NotificationComponent, selector: "rs-notification", inputs: ["visible", "toast", "displayTimeout", "message", "type", "customConfig", "checkPasswordExpiry", "customExpirationMessage", "closeable"], outputs: ["visibleChange"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "ngmodule", type: SelectModule }, { kind: "component", type: i3$1.SelectComponent, selector: "rs-select", inputs: ["autocomplete", "label", "placeholder", "validation", "errors", "appendTo", "hideErrorMessage", "id", "multiple", "searchable", "clearable", "items", "selectValue", "tabindex", "disabled", "color"], outputs: ["change", "close"] }, { kind: "ngmodule", type: InputModule }, { kind: "component", type: i4.InputComponent, selector: "rs-input", inputs: ["autocomplete", "list", "suffix", "prefix", "placeholder", "size", "step", "maxlength", "label", "max", "min", "validation", "errors", "value", "mask", "type", "hideErrorMessage", "tabindex", "id", "disabled", "color"] }, { kind: "component", type: i4.InputPrefixComponent, selector: "rs-input-prefix" }, { kind: "ngmodule", type: ButtonModule }, { kind: "component", type: i2.ButtonComponent, selector: "button[rs-button], button[rs-raised-button], button[rs-outlined-button]", inputs: ["color"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: PhoneFactorComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, imports: [FactorComponent, NotificationModule, ReactiveFormsModule, SelectModule, InputModule, ButtonModule], template: "<lib-factor [labels]=\"labels\" profileKey=\"phoneNumber\" [pack]=\"pack\" (nextStep)=\"nextStep.emit($event)\"\n  (continueEnrollment)=\"continueEnrollment.emit($event)\" (resendCode)=\"resendCode.emit($event)\"\n  (resetResendStatus)=\"resetResendStatus.emit($event)\" (verifyCode)=\"verifyCode.emit($event)\"\n  (removeFactor)=\"removeFactor.emit($event)\" (edit)=\"edit.emit($event)\">\n  @if (pack.errors) {\n    <rs-notification type=\"error\" [message]=\"labels.setupCodeFailed\" visible></rs-notification>\n  }\n  <p class=\"factor-setup-description\">{{labels.setupDescription}}</p>\n  <form class=\"row\" [formGroup]=\"factorEnrollmentForm\">\n    <div class=\"col-12 col-md-6\">\n      <rs-select validation=\"eager\" [label]=\"labels.setupCountryCodeLabel\" formControlName=\"countryCode\"\n      [items]=\"countryCodes\" searchable></rs-select>\n    </div>\n    <div class=\"col-12 col-md-6\">\n      <rs-input #phone [label]=\"labels.setupPhoneNubmerLabel\" validation=\"eager\" formControlName=\"phoneNumber\"\n        [mask]=\"phoneMask\">\n        <rs-input-prefix>{{prefix}}</rs-input-prefix>\n      </rs-input>\n    </div>\n    <div class=\"col-12 factor-setup-actions\">\n      <button rs-button type=\"button\" (click)=\"nextStep.emit('none')\">{{labels.cancelBtn}}</button>\n      <button rs-outlined-button type=\"button\" (click)=\"submitEnrollment('call')\">{{labels.setupVoiceBtn}}</button>\n      <button rs-raised-button (click)=\"submitEnrollment('sms')\" type=\"button\">{{labels.setupSMSBtn}}</button>\n    </div>\n  </form>\n</lib-factor>\n", styles: [":host *,:host *:before,:host *:after{box-sizing:border-box}:host ::ng-deep rs-notification h3{font-size:16px}p{margin:0}.factor-setup-description{padding-bottom:15px}.factor-setup-actions{display:flex;flex-direction:column-reverse;text-align:right}.factor-setup-actions button{width:100%;margin-bottom:10px;margin-right:10px}.factor-setup-actions button:last-of-type{margin-right:0}@media (min-width: 768px){.factor-setup-actions{display:flex;flex-direction:row;justify-content:flex-end}.factor-setup-actions button{width:auto;margin-bottom:0}}\n"] }]
        }], ctorParameters: () => [{ type: i1.FormBuilder }], propDecorators: { phoneInput: [{
                type: ViewChild,
                args: ['phone']
            }] } });
class PhoneFactorLabelModel extends FactorLabelModel {
    constructor() {
        super(...arguments);
        this.setupCountryCodeLabel = 'Country Code';
        this.setupPhoneNubmerLabel = 'Phone Number';
        this.setupDescription = 'Please enter the phone number you would like to associate with multi-factor authentication.';
        this.setupSMSBtn = 'Verify With SMS';
        this.setupVoiceBtn = 'Verify With Voice';
        this.setupCodeFailed = 'There was an error setting up this factor';
        this.title = 'Phone Numbers';
        this.description = 'The number that you set up under this factor will be used only for authentication.';
        this.createBtn = 'Add Number';
        this.noEnrolled = 'No phone numbers set for MFA';
        this.verifyEditDescription = 'Entered the wrong number?';
    }
}

/*
export const reducer = {
  conversations: (existing: IConversation[], conversation: IConversation) => {
    return existing.some(x => x.id === conversation.id) ?
      existing.map(x => conversation.id !== x.id ? x : ({ ...x, ...conversation })) : [
        ...existing,
        conversation
      ]
  }
} */
const initialMultiFactorState = {
    errors: '',
    isFetching: false,
    factors: {
        phone: {
            enrollmentStatus: 'none',
            errors: '',
            factors: [],
            resendStatus: { status: 'none', message: '' },
            continuedEnrollment: {
                created: "",
                id: "",
                lastUpdated: "",
                profile: {},
                enrollment: "",
                factorType: "",
                provider: "",
                status: "NONE",
                vendorName: ""
            }
        }
    },
    factorCatalog: [],
};

const getFactor = (state, key) => state.multiFactor.factors[key];
const getAllFactors = (state) => state.multiFactor.factors;
const getFactorCatalog = (state) => state.multiFactor.factorCatalog;
const isFetching$1 = (state) => state.multiFactor.isFetching;
const getErrors = (state) => state.multiFactor.errors;
const getCodeRequest = (state, data) => ({
    factorType: data.meta.type,
    provider: 'OKTA',
    profile: (data.type === 'phone' ? { phoneNumber: data.meta.phoneNumber } : {})
});

class MultiFactorApiService {
    constructor(http, config) {
        this.http = http;
        this.config = config;
    }
    readEnrolledFactors() {
        return this.http.get(this.config.urls.factorsEnrolled);
    }
    deleteEnrolledFactor(factorId) {
        return this.http.delete(this.config.urls.factorsEnrolled + '/' + factorId);
    }
    deleteAllEnrolledFactor() {
        return this.http.delete(this.config.urls.factorsEnrolled + '/reset');
    }
    readFactorCatalog() {
        return this.http.get(this.config.urls.factorsCatalog);
    }
    resendFactorCode(request, factorId) {
        return this.http.post(this.config.urls.resendCode.replace('{factorId}', factorId), request);
    }
    createFactorCode(request) {
        return this.http.post(this.config.urls.sendCode, request);
    }
    createEnrollment(request) {
        return this.http.post(this.config.urls.verifyCode.replace('{factorId}', request.factorId), { passCode: request.code });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: MultiFactorApiService, deps: [{ token: i1$1.HttpClient }, { token: i1$2.BasicAuthConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: MultiFactorApiService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: MultiFactorApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$1.HttpClient }, { type: i1$2.BasicAuthConfig }] });

class MultiFactorAsyncService {
    constructor(lux, multiFactorApi, commonUserService) {
        this.lux = lux;
        this.multiFactorApi = multiFactorApi;
        this.commonUserService = commonUserService;
    }
    readFactors() {
        return of('').pipe(tap(() => this.lux.set.multiFactor(state => ({ ...state, isFetching: true, errors: '', factors: { ...initialMultiFactorState.factors }, factorCatalog: [...initialMultiFactorState.factorCatalog] }))), mergeMap(() => this.multiFactorApi.readFactorCatalog().pipe(map(catalog => catalog.map(x => ({ ...x, factorType: (x.factorType || '').toLowerCase() }))))), catchError((e) => {
            this.lux.set.multiFactor(state => ({
                ...state,
                isFetching: false,
                errors: 'CATALOG_ERROR'
            }));
            return throwError(() => null);
        }), tap(catalog => this.lux.set.multiFactor(state => ({ ...state, factorCatalog: catalog.map(x => x.factorType === 'call' || x.factorType === 'sms' ? 'phone' : x.factorType).filter((v, i, s) => s.indexOf(v) === i) }))), mergeMap(catalog => {
            const catalogTypes = catalog.map(x => x.factorType);
            return this.multiFactorApi.readEnrolledFactors().pipe(tap(factors => this.lux.set.multiFactor(state => ({
                ...state,
                isFetching: false,
                factors: factors
                    .map(x => ({ ...x, factorType: (x.factorType || '').toLowerCase() }))
                    .filter(x => catalogTypes.includes(x.factorType))
                    .reduce((bag, x) => ({
                    ...bag,
                    [x.factorType === 'call' || x.factorType === 'sms' ? 'phone' : x.factorType]: {
                        ...(bag[x.factorType === 'call' || x.factorType === 'sms' ? 'phone' : x.factorType] || {
                            ...initialMultiFactorState.factors[x.factorType === 'call' || x.factorType === 'sms' ? 'phone' : x.factorType]
                        }),
                        factors: [...(bag[x.factorType === 'call' || x.factorType === 'sms' ? 'phone' : x.factorType]?.factors || []), x]
                    }
                }), { ...initialMultiFactorState.factors })
            }))));
        }), catchError((e) => {
            if (e) {
                this.lux.set.multiFactor(state => ({
                    ...state,
                    isFetching: false,
                    errors: 'ENROLLED_ERROR'
                }));
            }
            return of(null);
        }));
    }
    deleteFactor(type, factorId) {
        return this.lux.get(state => ({ type, factorId })).pipe(first(), tap(() => this.lux.set.multiFactor(state => ({ ...state, isFetching: true }))), mergeMap(req => this.multiFactorApi.deleteEnrolledFactor(req.factorId).pipe(map(() => req))), tap((req) => this.lux.set.multiFactor(state => ({
            ...state,
            isFetching: false,
            factors: {
                ...state.factors,
                [type]: {
                    ...state.factors[type],
                    factors: state.factors[type].factors.filter(x => x.id !== req.factorId),
                    continuedEnrollment: { ...initialMultiFactorState.factors[type].continuedEnrollment }
                }
            }
        }))), catchError((e) => {
            console.log(e);
            this.lux.set.multiFactor(state => ({
                ...state,
                isFetching: false,
                factors: {
                    ...state.factors,
                    [type]: {
                        ...state.factors[type],
                        errors: 'DELETE_ERROR'
                    }
                }
            }));
            return of(null);
        }));
    }
    deleteAllFactors() {
        return of('').pipe(first(), tap(() => this.lux.set.multiFactor(state => ({ ...state, isFetching: true }))), mergeMap(req => this.multiFactorApi.deleteAllEnrolledFactor().pipe(map(() => req))), tap((req) => this.lux.set.multiFactor(state => ({
            ...state,
            isFetching: false,
            factors: Object.keys(state.factors).reduce((bag, key) => ({
                ...bag,
                [key]: {
                    ...state.factors[key],
                    factors: [],
                    enrollmentStatus: 'none'
                }
            }), {})
        }))), catchError((e) => {
            this.lux.set.multiFactor(state => ({
                ...state,
                isFetching: false,
                factors: Object.keys(state.factors).reduce((bag, key) => ({
                    ...bag,
                    [key]: {
                        ...state.factors[key],
                        errors: 'DELETE_ALL_ERROR'
                    }
                }), {})
            }));
            return of(null);
        }));
    }
    createEnrollment(type, code) {
        return this.lux.get(state => ({ type, code, factorId: state.multiFactor.factors[type].continuedEnrollment.id })).pipe(first(), tap(() => this.lux.set.multiFactor(state => ({ ...state, isFetching: true }))), mergeMap(req => this.multiFactorApi.createEnrollment(req)), tap((res) => this.lux.set.multiFactor(state => ({
            ...state,
            isFetching: false,
            factors: {
                ...state.factors,
                [type]: {
                    ...state.factors[type],
                    factors: [...state.factors[type].factors.filter(x => x.id !== state.factors[type].continuedEnrollment.id), res],
                    continuedEnrollment: { ...initialMultiFactorState.factors[type].continuedEnrollment }
                }
            }
        }))), catchError((e) => {
            console.log(e);
            this.lux.set.multiFactor(state => ({
                ...state,
                isFetching: false,
                factors: {
                    ...state.factors,
                    [type]: {
                        ...state.factors[type],
                        errors: 'There was an error creating an enrollment'
                    }
                }
            }));
            return of(null);
        }));
    }
    resendCode(type, factor) {
        return this.lux.get(state => {
            factor = factor || state.multiFactor.factors[type].continuedEnrollment;
            return {
                type,
                factor,
                req: getCodeRequest(state, {
                    type, meta: { type: factor.factorType, phoneNumber: factor.profile.phoneNumber }
                })
            };
        }).pipe(first(), tap((req) => this.lux.set.multiFactor(state => ({ ...state, isFetching: true, factors: { ...state.factors, [type]: { ...state.factors[type], continuedEnrollment: req.factor } } }))), mergeMap(data => this.multiFactorApi.resendFactorCode(data.req, data.factor.id)), tap(() => this.lux.set.multiFactor(state => ({
            ...state,
            isFetching: false,
            factors: {
                ...state.factors,
                [type]: {
                    ...state.factors[type],
                    resendStatus: {
                        status: 'success', message: 'Code sent succesfully'
                    }
                }
            }
        }))), catchError((e) => {
            console.log(e);
            this.lux.set.multiFactor(state => ({
                ...state,
                isFetching: false,
                factors: {
                    ...state.factors,
                    [type]: {
                        ...state.factors[type],
                        errors: 'RESEND_ERROR',
                        resendStatus: {
                            status: 'error', message: 'Please wait a while and try again'
                        }
                    }
                }
            }));
            return of(null);
        }));
    }
    createFactorCode(type, meta) {
        return this.lux.get(state => getCodeRequest(state, { type, meta })).pipe(first(), tap(() => this.lux.set.multiFactor(state => ({ ...state, isFetching: true, factors: { ...state.factors, [type]: { ...state.factors[type], errors: '' } } }))), mergeMap(req => this.multiFactorApi.createFactorCode(req)), tap((req) => this.lux.set.multiFactor(state => ({
            ...state,
            isFetching: false,
            factors: {
                ...state.factors,
                [type]: {
                    ...state.factors[type],
                    factors: [...state.factors[type].factors, req],
                    continuedEnrollment: req
                }
            }
        }))), catchError((e) => {
            console.log(e);
            this.lux.set.multiFactor(state => ({
                ...state,
                isFetching: false,
                factors: {
                    ...state.factors,
                    [type]: {
                        ...state.factors[type],
                        errors: (e.error?.errorCauses || [])[0]?.errorSummary || 'There was an error setting up this factor',
                    }
                }
            }));
            return of(null);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: MultiFactorAsyncService, deps: [{ token: i1$2.LuxHP }, { token: MultiFactorApiService }, { token: i1$2.CommonUserService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: MultiFactorAsyncService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: MultiFactorAsyncService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$2.LuxHP }, { type: MultiFactorApiService }, { type: i1$2.CommonUserService }] });

/**
 * Phone-factor
 *
 * @description use this component to manage a users MFA enrollment
 * @example
 * <lib-phone-factor></lib-phone-factor>
 */
class PhoneFactorContainer {
    constructor(lux, multiFactorAsync, config) {
        this.lux = lux;
        this.multiFactorAsync = multiFactorAsync;
        this.config = config;
        this.componentArea = undefined;
        this.componentInstance = undefined;
        this.labels = undefined;
        this.destroyKey = 'PhoneFactorContainer';
        this.factorPack$ = this.lux.get(state => getFactor(state, 'phone'), this.destroyKey);
    }
    ngOnInit() {
        this.loadComponent();
    }
    ngOnDestroy() {
        this.lux.destroy(this.destroyKey);
    }
    loadComponent() {
        this.componentArea.clear();
        this.componentInstance = this.componentArea.createComponent(PhoneFactorComponent).instance;
        this.componentInstance.labels = this.labels;
        this.lux.set.multiFactor(state => ({ ...state, factors: { ...state.factors, phone: { ...initialMultiFactorState.factors.phone } } }));
        this.factorPack$.subscribe(x => this.componentInstance.pack = x);
        this.componentInstance.nextStep.subscribe(x => this.moveStep(x));
        this.componentInstance.resetResendStatus.subscribe(x => this.lux.set.multiFactor(state => ({ ...state, factors: { ...state.factors, phone: { ...state.factors.phone, resendStatus: { status: 'none', message: '' } } } })));
        this.componentInstance.resendCode.subscribe(x => this.multiFactorAsync.resendCode('phone', x).subscribe());
        this.componentInstance.edit.subscribe(x => this.multiFactorAsync.deleteFactor('phone', x).subscribe(success => { if (success) {
            this.moveStep('setup');
        } }));
        this.componentInstance.continueEnrollment.subscribe(x => this.multiFactorAsync.resendCode('phone', x).subscribe(success => { if (success) {
            this.moveStep('verify-pending');
        } }));
        this.componentInstance.startVerification.subscribe(x => this.multiFactorAsync.createFactorCode('phone', x).subscribe(success => { if (success) {
            this.moveStep('verify-new');
        } }));
        this.componentInstance.verifyCode.subscribe(x => this.multiFactorAsync.createEnrollment('phone', x).subscribe(success => { if (success) {
            this.moveStep('none');
        } }));
        this.componentInstance.removeFactor.subscribe(x => this.multiFactorAsync.deleteFactor('phone', x).subscribe());
    }
    moveStep(step) {
        this.lux.set.multiFactor(state => ({ ...state, factors: { ...state.factors, phone: { ...state.factors.phone, enrollmentStatus: step, errors: '', resendStatus: { ...initialMultiFactorState.factors.phone.resendStatus } } } }));
        if (step === 'setup') {
            setTimeout(() => {
                this.componentInstance.phoneInput.focus();
            }, 0);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: PhoneFactorContainer, deps: [{ token: i1$2.LuxHP }, { token: MultiFactorAsyncService }, { token: i1$2.BasicAuthConfig }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.3", type: PhoneFactorContainer, isStandalone: true, selector: "lib-phone-factor", inputs: { labels: "labels" }, viewQueries: [{ propertyName: "componentArea", first: true, predicate: ["phoneFactor"], descendants: true, read: ViewContainerRef, static: true }], ngImport: i0, template: `<ng-container #phoneFactor></ng-container>`, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: PhoneFactorContainer, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-phone-factor',
                    template: `<ng-container #phoneFactor></ng-container>`,
                    standalone: true
                }]
        }], ctorParameters: () => [{ type: i1$2.LuxHP }, { type: MultiFactorAsyncService }, { type: i1$2.BasicAuthConfig }], propDecorators: { componentArea: [{
                type: ViewChild,
                args: ['phoneFactor', { read: ViewContainerRef, static: true }]
            }], labels: [{
                type: Input
            }] } });

class MultiFactorComponent {
    constructor() {
        this.hideLoader = undefined;
        this.layout = 'side-by-side';
        this.mfLabels = undefined;
        this.phoneLabels = undefined;
        this.isFetching = false;
        this.catalog = [];
        this.deleteAllFactors = new EventEmitter();
        this.errors = undefined;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: MultiFactorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.3", type: MultiFactorComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: "<div class=\"factors-title\">\n  <h2>{{mfLabels.title}}</h2>\n  <span></span>\n  @if (mfLabels.removeAllBtn) {\n    <button color=\"secondary\" rs-raised-button (click)=\"deleteAllFactors.emit()\"\n    >{{mfLabels.removeAllBtn}}</button>\n  }\n</div>\n<p>{{mfLabels.description}}</p>\n<rs-notification type=\"error\" [message]=\"errors === 'CATALOG_ERROR' ? mfLabels.catalogError : mfLabels.enrolledError\"\n[visible]=\"!!errors\"></rs-notification>\n<div class=\"factors\" [class.stacked]=\"layout === 'stacked'\">\n  @for (key of catalog; track $index) {\n    @switch (key) {\n      @case ('phone') {\n        <lib-phone-factor [labels]=\"phoneLabels\"></lib-phone-factor>\n      }\n    }\n  }\n  @if (isFetching && !hideLoader) {\n    <rs-loader position=\"absolute\"></rs-loader>\n  }\n</div>\n", styles: [":host *,:host *:before,:host *:after{box-sizing:border-box}:host ::ng-deep rs-notification h3{font-size:16px}.factors-title{display:flex;align-items:center}.factors-title span{flex:1}.factors{display:flex;flex-direction:column}.factors lib-phone-factor{flex:1}@media (min-width: 992px){.factors{flex-direction:row}.factors.stacked{flex-direction:column}}\n"], dependencies: [{ kind: "ngmodule", type: ButtonModule }, { kind: "component", type: i2.ButtonComponent, selector: "button[rs-button], button[rs-raised-button], button[rs-outlined-button]", inputs: ["color"] }, { kind: "ngmodule", type: NotificationModule }, { kind: "component", type: i2$1.NotificationComponent, selector: "rs-notification", inputs: ["visible", "toast", "displayTimeout", "message", "type", "customConfig", "checkPasswordExpiry", "customExpirationMessage", "closeable"], outputs: ["visibleChange"] }, { kind: "component", type: PhoneFactorContainer, selector: "lib-phone-factor", inputs: ["labels"] }, { kind: "ngmodule", type: LoaderModule }, { kind: "component", type: i3$2.LoaderComponent, selector: "rs-loader", inputs: ["position", "imageSrc", "color"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: MultiFactorComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, imports: [ButtonModule, NotificationModule, PhoneFactorContainer, LoaderModule], template: "<div class=\"factors-title\">\n  <h2>{{mfLabels.title}}</h2>\n  <span></span>\n  @if (mfLabels.removeAllBtn) {\n    <button color=\"secondary\" rs-raised-button (click)=\"deleteAllFactors.emit()\"\n    >{{mfLabels.removeAllBtn}}</button>\n  }\n</div>\n<p>{{mfLabels.description}}</p>\n<rs-notification type=\"error\" [message]=\"errors === 'CATALOG_ERROR' ? mfLabels.catalogError : mfLabels.enrolledError\"\n[visible]=\"!!errors\"></rs-notification>\n<div class=\"factors\" [class.stacked]=\"layout === 'stacked'\">\n  @for (key of catalog; track $index) {\n    @switch (key) {\n      @case ('phone') {\n        <lib-phone-factor [labels]=\"phoneLabels\"></lib-phone-factor>\n      }\n    }\n  }\n  @if (isFetching && !hideLoader) {\n    <rs-loader position=\"absolute\"></rs-loader>\n  }\n</div>\n", styles: [":host *,:host *:before,:host *:after{box-sizing:border-box}:host ::ng-deep rs-notification h3{font-size:16px}.factors-title{display:flex;align-items:center}.factors-title span{flex:1}.factors{display:flex;flex-direction:column}.factors lib-phone-factor{flex:1}@media (min-width: 992px){.factors{flex-direction:row}.factors.stacked{flex-direction:column}}\n"] }]
        }] });
class MultiFactorLabelModel {
    constructor() {
        this.description = 'Multi-factor authentication or MFA is a security measure to help keep your account secure. It requires setting up another device where you receive a code to verify you are the true account holder.';
        this.title = 'Multi-factor Management';
        this.catalogError = 'Unable to fetch the multi-factors catalog.';
        this.enrolledError = 'Unable to fetch your enrolled factors.';
        this.removeAllBtn = 'Remove All';
    }
}

/**
 * Multi-factor
 *
 * @description use this component to manage a users MFA enrollment
 * @example
 * <!-- rs-doc {link: 'Out of the box MFA'} -->
 * <lib-multi-factor></lib-multi-factor>
 * @example
 * <!-- rs-doc {link: 'MFA with remove all label empty'} -->
 * <lib-multi-factor [multifactorLabels]="{removeAllBtn: ''}"></lib-multi-factor>
 */
class MultiFactorContainer {
    /** if you would like to use your own loader, you can turn this switch on */
    get hideLoader() { return this._hideLoader; }
    set hideLoader(value) { this._hideLoader = coerceBooleanProperty(value); }
    /** allow you to change any label in the library */
    // @Input() labels: IMultiFactorLabelModel = undefined as any;
    constructor(lux, multiFactorAsync, config) {
        this.lux = lux;
        this.multiFactorAsync = multiFactorAsync;
        this.config = config;
        this.componentArea = undefined;
        this.componentInstance = undefined;
        /** you have the option to have the layout stacked on top or side by side. desktop only */
        this.layout = 'side-by-side';
        /** you can override any text within this component that deals with phone factors */
        this.phoneLabels = undefined;
        /** you can override any text within this component that deals with multifactor */
        this.multifactorLabels = undefined;
        this.destroyKey = 'MultiFactorContainer';
        this.isFetching$ = this.lux.get(isFetching$1);
        this.errors$ = this.lux.get(getErrors);
        this.factorCatalog$ = this.lux.get(getFactorCatalog);
        this._hideLoader = undefined;
    }
    ngOnInit() {
        this.loadComponent();
    }
    ngOnDestroy() {
        this.lux.destroy(this.destroyKey);
    }
    loadComponent() {
        this.componentArea.clear();
        this.componentInstance = this.componentArea.createComponent(MultiFactorComponent).instance;
        this.componentInstance.mfLabels = !this.multifactorLabels ? new MultiFactorLabelModel() : { ...new MultiFactorLabelModel(), ...this.multifactorLabels };
        this.componentInstance.phoneLabels = !this.phoneLabels ? new PhoneFactorLabelModel() : { ...new PhoneFactorLabelModel(), ...this.phoneLabels };
        this.componentInstance.layout = this.layout;
        this.componentInstance.hideLoader = this.hideLoader;
        this.multiFactorAsync.readFactors().subscribe();
        this.errors$.subscribe(x => this.componentInstance.errors = x);
        this.isFetching$.subscribe(x => this.componentInstance.isFetching = x);
        this.factorCatalog$.subscribe(x => { this.componentInstance.catalog = x; });
        this.componentInstance.deleteAllFactors.subscribe(() => this.multiFactorAsync.deleteAllFactors().subscribe());
    }
    /* eslint-disable */
    static { this.ngAcceptInputType_hideLoader = undefined; }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: MultiFactorContainer, deps: [{ token: i1$2.LuxHP }, { token: MultiFactorAsyncService }, { token: i1$2.BasicAuthConfig }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.3", type: MultiFactorContainer, isStandalone: true, selector: "lib-multi-factor", inputs: { layout: "layout", phoneLabels: "phoneLabels", multifactorLabels: "multifactorLabels", hideLoader: "hideLoader" }, viewQueries: [{ propertyName: "componentArea", first: true, predicate: ["multiFactor"], descendants: true, read: ViewContainerRef, static: true }], ngImport: i0, template: `<ng-container #multiFactor></ng-container>`, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: MultiFactorContainer, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-multi-factor',
                    template: `<ng-container #multiFactor></ng-container>`,
                    standalone: true
                }]
        }], ctorParameters: () => [{ type: i1$2.LuxHP }, { type: MultiFactorAsyncService }, { type: i1$2.BasicAuthConfig }], propDecorators: { componentArea: [{
                type: ViewChild,
                args: ['multiFactor', { read: ViewContainerRef, static: true }]
            }], layout: [{
                type: Input
            }], phoneLabels: [{
                type: Input
            }], multifactorLabels: [{
                type: Input
            }], hideLoader: [{
                type: Input
            }] } });

class MultiFactorModule {
    constructor(lux) {
        const multiFactorState = JSON.parse(sessionStorage.getItem('multi-factor-state')) || initialMultiFactorState;
        lux.allChanges().subscribe(state => sessionStorage.setItem('multi-factor-state', JSON.stringify(state.multiFactor || multiFactorState)));
        lux.register('multiFactor', multiFactorState);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: MultiFactorModule, deps: [{ token: i1$2.LuxHP }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.3", ngImport: i0, type: MultiFactorModule, imports: [MultiFactorContainer], exports: [MultiFactorContainer] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: MultiFactorModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: MultiFactorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        MultiFactorContainer
                    ],
                    exports: [MultiFactorContainer]
                }]
        }], ctorParameters: () => [{ type: i1$2.LuxHP }] });

class ChangePasswordComponent {
    constructor(fb) {
        this.fb = fb;
        this.labels = undefined;
        this.startChange = undefined;
        this.passwordForm = undefined;
        this.validationParts = undefined;
        this.validationPWLength = undefined;
        this.maxLength = undefined;
        this.changePass = new EventEmitter();
        this.hideNote = new EventEmitter();
        this.note = {};
        this.validatePart = (key, part) => (control) => {
            if (!part.test(control.value)) {
                return { [key]: true };
            }
            return null;
        };
        this.matchPasswords = (control) => {
            const confirmPassword = control.root.get('confirmPass')?.value || '';
            if (confirmPassword) {
                const password = control.root.get('newPass').value || '';
                if (confirmPassword !== password) {
                    control.root.get('confirmPass')?.setErrors({ mismatch: true });
                    return { mismatch: true };
                }
                else {
                    control.root.get('confirmPass')?.setErrors(null);
                }
            }
            return null;
        };
    }
    ngOnInit() {
        this.passwordForm = this.fb.group({
            currentPass: ['', Validators.required],
            newPass: ['', [Validators.required, Validators.maxLength(this.maxLength),
                    ...Object.keys(this.validationPWLength).map(key => this.validatePart(key, this.validationPWLength[key])),
                    ...Object.keys(this.validationParts).map(key => this.validatePart(key, this.validationParts[key]))]],
            confirmPass: ['', [Validators.required]]
        }, { validator: this.matchPasswords });
    }
    submitChange() {
        if (this.passwordForm.valid) {
            const value = this.passwordForm.value;
            this.changePass.emit({
                currentPassword: value.currentPass,
                newPassword: value.newPass
            });
        }
    }
    cancelChange() {
        this.startChange = false;
        this.passwordForm.reset({ currentPass: '', newPass: '', confirmPass: '' });
    }
    passwordMessaging() {
        if (this.note.message === 'CHANGE_PASSWORD_SUCCESS') {
            // success
            return this.labels.changePasswordSuccess;
        }
        else if (this.note.message === 'CHANGE_PASSWORD_FAILED') {
            // failed generic
            return this.labels.changePasswordFailed;
        }
        else {
            if (this.note.messageStatus === 400 && this.labels.changePasswordFailed400) {
                // failed with 400 but has an override
                return this.labels.changePasswordFailed400;
            }
            else if (this.note.messageStatus === 500 && this.labels.changePasswordFailed500) {
                // failed with 500 but has an override
                return this.labels.changePasswordFailed500;
            }
            // this message is from the api 
            return this.note.message;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ChangePasswordComponent, deps: [{ token: i1.FormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.3", type: ChangePasswordComponent, isStandalone: true, selector: "lib-change-password", ngImport: i0, template: "<div class=\"change-pass-title\">\n  <h2>{{labels.title}}</h2>\n</div>\n@if (note.status !== 'none') {\n<rs-notification [type]=\"note.status\"\n  [message]=\"passwordMessaging()\"\n  visible closeable displayTimeout=\"10000\" (visibleChange)=\"hideNote.emit()\"></rs-notification>\n}\n<div role=\"group\" aria-labelledby=\"change-password-label\">\n  <p id=\"change-password-label\" [attr.aria-label]=\"labels.description\">{{labels.description}}</p>\n  <form class=\"row\" [formGroup]=\"passwordForm\" (ngSubmit)=\"submitChange()\">\n    <div class=\"col-12\">\n      @if (!startChange) {\n      <button rs-raised-button type=\"button\" (click)=\"startChange = true\">Change Password</button>\n      }\n    </div>\n    @if (startChange) {\n    <rs-input validation=\"eager\" type=\"password\" #current aria-required=\"true\" formControlName=\"currentPass\" class=\"col-12 col-md-4\"\n      label=\"Current Password\">\n      <rs-input-suffix>\n        <button rs-button type=\"button\" class=\"no-outline\" (click)=\"current.type = current.type !== 'text' ? 'text' : 'password'\" [title]=\"current.type === 'password' ? 'Show Password' : 'Hide Password'\">\n          <div *ngIf=\"current.type =='password'\" title=\"Show password\"><ng-container *ngTemplateOutlet=\"visibleIcon\"></ng-container></div>\n          <div *ngIf=\"current.type =='text'\" title=\"Hide password\"><ng-container *ngTemplateOutlet=\"visibleOffIcon\"></ng-container></div>\n        </button>\n      </rs-input-suffix>\n    </rs-input>\n    <rs-input validation=\"eager\" type=\"password\" aria-required=\"true\" #pass formControlName=\"newPass\" class=\"col-12 col-md-4\"\n      label=\"New Password\">\n      <rs-input-suffix>\n        <button rs-button type=\"button\" class=\"no-outline\" (click)=\"pass.type = pass.type !== 'text' ? 'text' : 'password'\" [title]=\"pass.type === 'password' ? 'Show Password' : 'Hide Password'\"> \n          <div *ngIf=\"pass.type =='password'\" title=\"Show passowrd\"><ng-container *ngTemplateOutlet=\"visibleIcon\"></ng-container></div>\n          <div *ngIf=\"pass.type =='text'\" title=\"Hide password\"><ng-container *ngTemplateOutlet=\"visibleOffIcon\"></ng-container></div>\n        </button>\n      </rs-input-suffix></rs-input>\n    <rs-input validation=\"eager\" type=\"password\" aria-required=\"true\" #confirm formControlName=\"confirmPass\" class=\"col-12 col-md-4\"\n      label=\"Confirm Password\">\n      <rs-input-suffix>\n        <button rs-button type=\"button\" class=\"no-outline\" (click)=\"confirm.type = confirm.type !== 'text' ? 'text' : 'password'\" [title]=\"confirm.type === 'password' ? 'Show Password' : 'Hide Password'\">\n          <div *ngIf=\"confirm.type =='password'\" title=\"Show Password\"><ng-container *ngTemplateOutlet=\"visibleIcon\"></ng-container></div>\n          <div *ngIf=\"confirm.type =='text'\" title=\"Hide Password\"><ng-container *ngTemplateOutlet=\"visibleOffIcon\"></ng-container></div>\n        </button>\n      </rs-input-suffix></rs-input>\n    <div class=\"change-pass-actions col-12\">\n      <button rs-button type=\"button\" (click)=\"cancelChange()\">Cancel</button>\n      <button rs-raised-button [disabled]=\"passwordForm.invalid\">Submit</button>\n    </div>\n    }\n  </form>\n</div>\n\n<ng-template #visibleIcon>\n    <svg role=\"img\" aria-label=\"Show password\" xmlns=\"http://www.w3.org/2000/svg\" height=\"22px\" viewBox=\"0 -960 960 960\" width=\"22px\" fill=\"#000000\">\n      <path d=\"M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z\"/>\n    </svg>\n</ng-template>\n\n<ng-template #visibleOffIcon>\n    <svg role=\"img\" aria-label=\"Hide password\" xmlns=\"http://www.w3.org/2000/svg\" height=\"22px\" viewBox=\"0 -960 960 960\" width=\"22px\" fill=\"#000000\">\n      <path d=\"m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z\"/>\n    </svg>\n</ng-template>", styles: [":host *,:host *:before,:host *:after{box-sizing:border-box}:host ::ng-deep rs-notification h3{font-size:16px}.change-pass-title{display:flex;align-items:center}.change-pass-title span{flex:1}.change-pass-actions{text-align:right;display:flex;flex-direction:column-reverse}.change-pass-actions>button{width:100%}rs-input-suffix button{min-width:0;padding:0}@media (min-width: 768px){.change-pass-actions{display:block}.change-pass-actions>button{width:auto}}.no-outline{outline:none!important}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "ngmodule", type: ButtonModule }, { kind: "component", type: i2.ButtonComponent, selector: "button[rs-button], button[rs-raised-button], button[rs-outlined-button]", inputs: ["color"] }, { kind: "ngmodule", type: InputModule }, { kind: "component", type: i4.InputComponent, selector: "rs-input", inputs: ["autocomplete", "list", "suffix", "prefix", "placeholder", "size", "step", "maxlength", "label", "max", "min", "validation", "errors", "value", "mask", "type", "hideErrorMessage", "tabindex", "id", "disabled", "color"] }, { kind: "component", type: i4.InputSuffixComponent, selector: "rs-input-suffix" }, { kind: "ngmodule", type: NotificationModule }, { kind: "component", type: i2$1.NotificationComponent, selector: "rs-notification", inputs: ["visible", "toast", "displayTimeout", "message", "type", "customConfig", "checkPasswordExpiry", "customExpirationMessage", "closeable"], outputs: ["visibleChange"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ChangePasswordComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-change-password', standalone: true, imports: [CommonModule, ButtonModule, InputModule, NotificationModule, ReactiveFormsModule], template: "<div class=\"change-pass-title\">\n  <h2>{{labels.title}}</h2>\n</div>\n@if (note.status !== 'none') {\n<rs-notification [type]=\"note.status\"\n  [message]=\"passwordMessaging()\"\n  visible closeable displayTimeout=\"10000\" (visibleChange)=\"hideNote.emit()\"></rs-notification>\n}\n<div role=\"group\" aria-labelledby=\"change-password-label\">\n  <p id=\"change-password-label\" [attr.aria-label]=\"labels.description\">{{labels.description}}</p>\n  <form class=\"row\" [formGroup]=\"passwordForm\" (ngSubmit)=\"submitChange()\">\n    <div class=\"col-12\">\n      @if (!startChange) {\n      <button rs-raised-button type=\"button\" (click)=\"startChange = true\">Change Password</button>\n      }\n    </div>\n    @if (startChange) {\n    <rs-input validation=\"eager\" type=\"password\" #current aria-required=\"true\" formControlName=\"currentPass\" class=\"col-12 col-md-4\"\n      label=\"Current Password\">\n      <rs-input-suffix>\n        <button rs-button type=\"button\" class=\"no-outline\" (click)=\"current.type = current.type !== 'text' ? 'text' : 'password'\" [title]=\"current.type === 'password' ? 'Show Password' : 'Hide Password'\">\n          <div *ngIf=\"current.type =='password'\" title=\"Show password\"><ng-container *ngTemplateOutlet=\"visibleIcon\"></ng-container></div>\n          <div *ngIf=\"current.type =='text'\" title=\"Hide password\"><ng-container *ngTemplateOutlet=\"visibleOffIcon\"></ng-container></div>\n        </button>\n      </rs-input-suffix>\n    </rs-input>\n    <rs-input validation=\"eager\" type=\"password\" aria-required=\"true\" #pass formControlName=\"newPass\" class=\"col-12 col-md-4\"\n      label=\"New Password\">\n      <rs-input-suffix>\n        <button rs-button type=\"button\" class=\"no-outline\" (click)=\"pass.type = pass.type !== 'text' ? 'text' : 'password'\" [title]=\"pass.type === 'password' ? 'Show Password' : 'Hide Password'\"> \n          <div *ngIf=\"pass.type =='password'\" title=\"Show passowrd\"><ng-container *ngTemplateOutlet=\"visibleIcon\"></ng-container></div>\n          <div *ngIf=\"pass.type =='text'\" title=\"Hide password\"><ng-container *ngTemplateOutlet=\"visibleOffIcon\"></ng-container></div>\n        </button>\n      </rs-input-suffix></rs-input>\n    <rs-input validation=\"eager\" type=\"password\" aria-required=\"true\" #confirm formControlName=\"confirmPass\" class=\"col-12 col-md-4\"\n      label=\"Confirm Password\">\n      <rs-input-suffix>\n        <button rs-button type=\"button\" class=\"no-outline\" (click)=\"confirm.type = confirm.type !== 'text' ? 'text' : 'password'\" [title]=\"confirm.type === 'password' ? 'Show Password' : 'Hide Password'\">\n          <div *ngIf=\"confirm.type =='password'\" title=\"Show Password\"><ng-container *ngTemplateOutlet=\"visibleIcon\"></ng-container></div>\n          <div *ngIf=\"confirm.type =='text'\" title=\"Hide Password\"><ng-container *ngTemplateOutlet=\"visibleOffIcon\"></ng-container></div>\n        </button>\n      </rs-input-suffix></rs-input>\n    <div class=\"change-pass-actions col-12\">\n      <button rs-button type=\"button\" (click)=\"cancelChange()\">Cancel</button>\n      <button rs-raised-button [disabled]=\"passwordForm.invalid\">Submit</button>\n    </div>\n    }\n  </form>\n</div>\n\n<ng-template #visibleIcon>\n    <svg role=\"img\" aria-label=\"Show password\" xmlns=\"http://www.w3.org/2000/svg\" height=\"22px\" viewBox=\"0 -960 960 960\" width=\"22px\" fill=\"#000000\">\n      <path d=\"M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z\"/>\n    </svg>\n</ng-template>\n\n<ng-template #visibleOffIcon>\n    <svg role=\"img\" aria-label=\"Hide password\" xmlns=\"http://www.w3.org/2000/svg\" height=\"22px\" viewBox=\"0 -960 960 960\" width=\"22px\" fill=\"#000000\">\n      <path d=\"m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z\"/>\n    </svg>\n</ng-template>", styles: [":host *,:host *:before,:host *:after{box-sizing:border-box}:host ::ng-deep rs-notification h3{font-size:16px}.change-pass-title{display:flex;align-items:center}.change-pass-title span{flex:1}.change-pass-actions{text-align:right;display:flex;flex-direction:column-reverse}.change-pass-actions>button{width:100%}rs-input-suffix button{min-width:0;padding:0}@media (min-width: 768px){.change-pass-actions{display:block}.change-pass-actions>button{width:auto}}.no-outline{outline:none!important}\n"] }]
        }], ctorParameters: () => [{ type: i1.FormBuilder }] });
class ChangePasswordLabelModel {
    constructor() {
        this.title = 'Password Management';
        this.description = 'Use this form to change your password.';
        this.changePasswordBtn = 'Change Password';
        this.changePasswordFailed = 'Failed to change password, please check requirements and try again.';
        this.changePasswordFailed400 = '';
        this.changePasswordFailed500 = '';
        this.changePasswordSuccess = 'Successfully updated password.';
    }
}

const isFetching = (state) => state.changePassword.isFetching;
const getStatus = (state) => ({ status: state.changePassword.status, message: state.changePassword.message, messageStatus: state.changePassword.messageStatus });

class ChangePasswordApiService {
    constructor(http, config) {
        this.http = http;
        this.config = config;
    }
    changePass(data) {
        return this.http.post(this.config.urls.userChangePassword, data).pipe(map(() => true));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ChangePasswordApiService, deps: [{ token: i1$1.HttpClient }, { token: i1$2.BasicAuthConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ChangePasswordApiService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ChangePasswordApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$1.HttpClient }, { type: i1$2.BasicAuthConfig }] });

class ChangePasswordAsyncService {
    constructor(lux, changePasswordApi) {
        this.lux = lux;
        this.changePasswordApi = changePasswordApi;
    }
    changePass(data) {
        return of(data).pipe(tap(() => this.lux.set.changePassword(state => ({ ...state, isFetching: true, message: '', status: 'none' }))), mergeMap(req => this.changePasswordApi.changePass(req)), tap(() => this.lux.set.changePassword(state => ({ ...state, isFetching: false, message: 'CHANGE_PASSWORD_SUCCESS', status: 'success' }))), catchError((e) => {
            let message = 'CHANGE_PASSWORD_FAILED';
            let messageStatus = 0;
            if (e.error.apiErrorList && e.error.apiErrorList.length && (e.status === 400 || e.status === 500)) {
                message = e.error.apiErrorList[0].errorMessage;
                messageStatus = e.status;
            }
            this.lux.set.changePassword(state => ({
                ...state,
                isFetching: false,
                status: 'error',
                message,
                messageStatus
            }));
            return of(null);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ChangePasswordAsyncService, deps: [{ token: i1$2.LuxHP }, { token: ChangePasswordApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ChangePasswordAsyncService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ChangePasswordAsyncService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$2.LuxHP }, { type: ChangePasswordApiService }] });

/**
 * Change Password
 *
 * @description a component that allows you to change your password. make sure you match your keys to your errors in Error Message Map
 * @example
 * <lib-change-password [labels]="{changePasswordFailed400: 'Call failed with 400'}"></lib-change-password>
 */
class ChangePasswordContainer {
    constructor(lux, changePassAsync) {
        this.lux = lux;
        this.changePassAsync = changePassAsync;
        this.componentArea = undefined;
        this.componentInstance = undefined;
        /** use this input if you want to change any of the text */
        this.labels = {};
        /** max length of a new password */
        this.maxLength = 25;
        /** individual part of password that are required. the key maps to ErrorMessageMap */
        this.validationParts = {
            lowercase: new RegExp('.*[a-z].*'),
            uppercase: new RegExp('.*[A-Z].*'),
            number: new RegExp('.*\\d.*'),
            special: new RegExp('.*[$@!%?&_# ].*')
        };
        this.validationPwLength = {
            zMinLength: new RegExp('^.{12,}$')
        };
        this.destroyKey = 'ChangePasswordContainer';
        this.status$ = this.lux.get(getStatus, this.destroyKey);
    }
    ngOnInit() {
        this.loadComponent();
    }
    ngOnDestroy() {
        // this.lux.destroy(this.destroyKey);
    }
    loadComponent() {
        this.componentArea.clear();
        this.componentInstance = this.componentArea.createComponent(ChangePasswordComponent).instance;
        this.componentInstance.labels = { ...new ChangePasswordLabelModel(), ...this.labels };
        this.componentInstance.validationParts = this.validationParts;
        this.componentInstance.validationPWLength = this.validationPwLength;
        this.componentInstance.maxLength = this.maxLength;
        this.status$.subscribe(x => this.componentInstance.note = x);
        this.componentInstance.changePass.subscribe(x => this.changePassAsync.changePass(x).subscribe(z => {
            this.componentInstance.startChange = !z;
            if (z) {
                this.componentInstance.passwordForm.reset({
                    currentPass: '',
                    newPass: '',
                    confirmPass: ''
                });
            }
        }));
        this.componentInstance.hideNote.subscribe(() => this.lux.set.changePassword(state => ({ ...state, status: 'none', message: '' })));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ChangePasswordContainer, deps: [{ token: i1$2.LuxHP }, { token: ChangePasswordAsyncService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.3", type: ChangePasswordContainer, isStandalone: true, selector: "lib-change-password", inputs: { labels: "labels", maxLength: "maxLength", validationParts: "validationParts" }, viewQueries: [{ propertyName: "componentArea", first: true, predicate: ["changePassword"], descendants: true, read: ViewContainerRef, static: true }], ngImport: i0, template: `<ng-container #changePassword></ng-container>`, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ChangePasswordContainer, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-change-password',
                    template: `<ng-container #changePassword></ng-container>`,
                    standalone: true
                }]
        }], ctorParameters: () => [{ type: i1$2.LuxHP }, { type: ChangePasswordAsyncService }], propDecorators: { componentArea: [{
                type: ViewChild,
                args: ['changePassword', { read: ViewContainerRef, static: true }]
            }], labels: [{
                type: Input
            }], maxLength: [{
                type: Input
            }], validationParts: [{
                type: Input
            }] } });

const initialChangePasswordState = {
    status: 'none',
    message: '',
    messageStatus: 0,
    isFetching: false,
};

class ChangePasswordModule {
    constructor(lux) {
        const changePasswordState = JSON.parse(sessionStorage.getItem('change-password-state')) || initialChangePasswordState;
        lux.allChanges().subscribe(state => sessionStorage.setItem('change-password-state', JSON.stringify(state.changePassword || changePasswordState)));
        lux.register('changePassword', changePasswordState);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ChangePasswordModule, deps: [{ token: i1$2.LuxHP }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.3", ngImport: i0, type: ChangePasswordModule, imports: [ChangePasswordContainer], exports: [ChangePasswordContainer] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ChangePasswordModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ChangePasswordModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        ChangePasswordContainer
                    ],
                    exports: [ChangePasswordContainer]
                }]
        }], ctorParameters: () => [{ type: i1$2.LuxHP }] });

/*
 * Public API Surface of authentication-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ChangePasswordContainer, ChangePasswordModule, MultiFactorContainer, MultiFactorModule };
